import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

export default function GeneralTermsAndConditionsScreen() {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.resolvedLanguage;

  const SECTIONS = [
    { id: 1, rows: 12, isList: true }, // Inhaltsverzeichnis
    { id: 2, rows: 3 },
    { id: 3, rows: 9 },
    { id: 4, rows: 2 },
    { id: 5, rows: 3 },
    { id: 6, rows: 5 },
    { id: 7, rows: 1 },
    { id: 8, rows: 6 },
    { id: 9, rows: 5 },
    { id: 10, rows: 3 },
    { id: 11, rows: 1 },
    { id: 12, rows: 1 },
    { id: 13, rows: 1 },
  ];

  return (
    <Container>
      <div className="container small-container">
        <title>{t('conditions-screen-helmet')}</title>

        <h1 className="screen-heading">{t('conditions-screen-heading')}</h1>

        <Row className="text-container">
          <Col>
            {SECTIONS.map(({ id, rows, isList }) => (
              <div key={id} className="text-container-section">
                <h4>
                  {t(
                    `general-terms-and-conditions-screen-section-${id}-heading`
                  )}
                </h4>

                {isList ? (
                  <ol>
                    {Array.from({ length: rows }, (_, i) => (
                      <li key={i}>
                        {t(
                          `general-terms-and-conditions-screen-section-${id}-row-${
                            i + 1
                          }`
                        )}
                      </li>
                    ))}
                  </ol>
                ) : (
                  Array.from({ length: rows }, (_, i) => (
                    <p
                      key={i}
                      className="general-terms-and-conditions-content"
                      dangerouslySetInnerHTML={{
                        __html: t(
                          `general-terms-and-conditions-screen-section-${id}-row-${
                            i + 1
                          }`
                        ),
                      }}
                    />
                  ))
                )}
              </div>
            ))}

            {selectedLanguage !== 'de' && (
              <p className="translation-info">
                <i>
                  {t('general-terms-and-conditions-screen-translation-info')}
                </i>
              </p>
            )}
          </Col>
        </Row>
      </div>
    </Container>
  );
}
